import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { EventManager } from 'src/app/core';
import { AppQueries, Dispatcher, GetCRMStatus } from 'src/app/state';
import { DateUtil } from '../../util/date.util';
import { AppsService } from '../../services/apps.service';
import { FilterStartEndDateComponent } from '../filter-start-end-date/filter-start-end-date';
@Component({
  selector: 'app-filter-receivers',
  templateUrl: './filter-receivers.component.html',
  styleUrls: ['./filter-receivers.component.scss']
})
export class FilterReceiversComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('filterStartEndDate', { static: true }) filterStartEndDateComponent : FilterStartEndDateComponent;
  @Input() filterReceiver: any;
  subscriptions?: Subscription[] = [];
  receivers: any[] = [];
  summaryReceivers: any[] = [];
  products: any[] = [];
  productsAll: any[] = [];
  issuers: any[] = [];
  provinces: any[] = [];
  isClone: boolean = false;
  isSaved: boolean = false;
  kycStatus = [ {code: 'NOT_ACTIVE', name: 'Chưa kích hoạt' }, {code: 'NOT_FULL_INFO', name: 'Chưa đủ thông tin'}, 
  {code: 'NOT_KYC', name: 'Chưa KYC'}, {code: 'KYC', name: 'Đã KYC'}];
  typeCodes = [ {code: 'FUND', name: 'Quỹ' }, {code: 'GOLD', name: 'Vàng'}];
  statusList = [];
  targetStatus = [ {code: null, name: 'Tất cả' }, {code: true, name: 'Có mục tiêu'}, {code: false, name: 'Không có mục tiêu'}, ];
  editForm = this.fb.group({
    receiver: [''],
    issuer: [[]],
    product: [[]],
    province: [[]],
    crmStatus: [[]],
    kycStatusCode: [null],
    kycStatus: [null],
    isCreatedGoal: ['null'],
    status: [[]],
    gender: ['null'],
    valueAge: [null],
    startAge: [1],
    endAge: [100],
    activeStart: [undefined],
    activeEnd: [undefined],
    topAssetPercent: [undefined],
    topBuyingPercent: [undefined],
    description: ['', [Validators.required]],
    typeCode: [undefined],
    isHaveAsset: ['null'],
    isAllInvestor: [true],
    isAdvertising: [false],
  });
  valueAge: any;
  scheduledTime: any;
  slider: any;
  @Output() result: EventEmitter<any> = new EventEmitter();
  errors: any = {};
  constructor(
    private fb: FormBuilder,
    public eventManager: EventManager,
    private dispatcher: Dispatcher,
    private appQueries: AppQueries,
    private appsService: AppsService,
  ) {
  }
  ngOnInit() {
    this.subscriptions = [
      this.appQueries.products$
      .subscribe((products) => {
        this.productsAll = products.map((item) => { 
          return {
            id: item.id,
            shortName: item.shortName,
            issuerId: item.owner.userId
          }
        });
        this.products = this.productsAll.slice();
      }),
      this.appQueries.provinces$
      .subscribe((provinces) => {
        this.provinces = provinces;
      }),
      this.appQueries.issuers$
      .subscribe((issuers) => {
        this.issuers = issuers;
      }),
      this.appQueries.crmStatuses$
      .subscribe((crmStatuses) => {
        this.statusList = crmStatuses;
      }),
      this.editForm.get('issuer').valueChanges
      .subscribe((value: any) => {
        value = value || [];
        this.products = this.productsAll.filter((item) => value.some((issuer) => item.issuerId === issuer.userId));
      }),
    ];
  }
  ngAfterViewInit(): void {
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.filterReceiver && changes.filterReceiver.currentValue) {
      this.isClone = true;
      this.updateForm();
    }
  }
  disabledButton() {
    this.isSaved = true;
    if (this.editForm.value.receiver) {
      this.errors.email = true;
    } else {
      this.errors.email = false;
    }
    const keys = Object.keys(this.errors);
    const key = keys.find(key => this.errors[key]);
    return key ? true : false;
  }
  updateForm() {
    const filter = this.filterReceiver || {};
    let gender = filter.gender === 'null' || filter.gender === undefined ? 'null' : filter.gender ? '1' : '0';
    let isHaveAsset = filter.isHaveAsset === 'null' ? 'null' : filter.isHaveAsset ? '1' : '0';
    this.scheduledTime = new Date(filter.scheduledTime).getTime();
    this.receivers = filter.receivers || [];
    this.summaryReceivers = this.receivers.slice(0, 10);
    this.valueAge = [18, 100];
    this.valueAge[0] = filter.startAge || this.valueAge[0];
    this.valueAge[1] = filter.endAge || this.valueAge[1];
    this.editForm.patchValue({
      issuer: (filter.issuerIds || []).filter(item => item),
      product: (filter.productIds || []).filter(item => item),
      province: (filter.provinceIds || []).filter(item => item),
      kycStatusCode: filter.kycStatusCode,
      crmStatus: (filter.crmStatus || []).filter(item => item),
      isCreatedGoal: filter.isCreatedGoal + '',
      gender,
      isHaveAsset,
      startAge: filter.startAge,
      endAge: filter.endAge,
      activeStart: filter.activeStart,
      activeEnd: filter.activeEnd,
      topAssetPercent: filter.topAssetPercent,
      topBuyingPercent: filter.topBuyingPercent,
      isAllInvestor: filter.isAllInvestor,
      isAdvertising: filter.isAdvertising,
      typeCode: filter.typeCode
    });
  }
  patchValue(key, value) {
    this.editForm.patchValue({[key]: value});
    if (key === 'issuer') {
      this.products = this.productsAll.filter((item) => value.some((issuer) => item.issuerId === issuer.userId));
    }
  }
  changeSlider() {
    if (!this.slider) {
      return;
    }
    const values = this.slider.get() || [1, 100];
    this.editForm.patchValue({
      startAge: parseInt(values[0]),
      endAge: parseInt(values[1]),
    })
  }
  changeTime(event) {
    // const moreHouse = event.substring(6, 10) === 'AM' ? 0 : 12;
    // let hour: any = moreHouse ? parseInt(event.substring(0, 2)) + moreHouse : event.substring(0, 2);
    // const result = hour +  event.substring(2, 5);
    // return result;

    return event;
  }
  addEmail() {
    const text = this.editForm.value.receiver || '';
    const splits = text.split(',')
    this.receivers = [...splits, ...this.receivers];
    this.summaryReceivers = this.receivers.slice(0, 10);
    this.editForm.patchValue({
      receiver: ''
    })
  }
  cleanEmail() {
    this.receivers = []; 
    this.summaryReceivers = [];
  }
  deleteTag(index) {
    this.receivers.splice(index, 1);
    this.summaryReceivers = this.receivers.slice(0, 10);
  }
  emitData() {
    const valueAge = this.valueAge || [18, 100];
    const {startDate, endDate} = this.filterStartEndDateComponent.emitData();
    return {
      receivers: this.receivers || [],
      issuerIds: (this.editForm.value.issuer || []).filter(item => item).map(item => item.userId) || [],
      productIds:  (this.editForm.value.product || []).filter(item => item).map(item => item.id) || [],
      provinceIds:  (this.editForm.value.province || []).filter(item => item).map(item => item.id) || [],
      crmStatusCodes: (this.editForm.value.status || []).filter(item => item).map(item => item.code) || [],
      kycStatusCode: this.editForm.value.kycStatusCode || undefined,
      isCreatedGoal: this.editForm.value.isCreatedGoal === 'null' ? undefined : this.editForm.value.isCreatedGoal === 'true' ? true : false,
      startAge: valueAge[0],
      endAge: valueAge[1],
      isHaveAsset: this.editForm.value.isHaveAsset === 'null' ? undefined : parseInt(this.editForm.value.isHaveAsset),
      typeCode: this.editForm.value.typeCode,
      productTypeCodes: this.editForm.value.isHaveAsset !== '0' ? [] :
        !this.editForm.value.typeCode ? [] : this.editForm.value.typeCode === 'FUND' ? ["NEW_FUND", "TRADING_FUND"] :  ["GOLD"],
      gender: this.editForm.value.gender === 'null' ? undefined : parseInt(this.editForm.value.gender),
      activeStart: startDate,
      activeEnd: endDate,
      topAssetPercent: this.editForm.value.topAssetPercent || undefined,
      topBuyingPercent: this.editForm.value.topBuyingPercent || undefined,
      isAllInvestor: this.editForm.value.isAllInvestor,
      isAdvertising: this.editForm.value.isAdvertising,
      scheduledTime: this.scheduledTime || undefined
    }
  }
}
